import { render, staticRenderFns } from "./CardBody.vue?vue&type=template&id=fc634608&scoped=true"
import script from "./CardBody.vue?vue&type=script&lang=js"
export * from "./CardBody.vue?vue&type=script&lang=js"
import style0 from "./CardBody.vue?vue&type=style&index=0&id=fc634608&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc634608",
  null
  
)

export default component.exports